import firebase from "firebase"

export function obtenerFecha() 
{
    const now = new Date();
    const dia = String(now.getDate()).padStart(2, '0');
    const mes = String(now.getMonth() + 1).padStart(2, '0');
    const anio = now.getFullYear();
    const hora = String(now.getHours()).padStart(2, '0');
    const minutos = String(now.getMinutes()).padStart(2, '0');
    
    return `${dia}/${mes}/${anio} ${hora}:${minutos}`;
}


export function getDate()
{
    var date=firebase.firestore.Timestamp.now().seconds;
    return date;
}

export function CalculateDiff(DateCostumer)
{
    var Now=(firebase.firestore.Timestamp.now().seconds);
    var diffSeconds= Now - parseInt(DateCostumer);
    var diff = new Date(diffSeconds * 1000).toISOString().substr(11, 8);
    var diffHHMM=String(diff).slice(0,-3);
    return diffHHMM;
}

function convertirHoraAMinutos(hora) {
    const [horas, minutos] = hora.split(":");
    return parseInt(horas) * 60 + parseInt(minutos);
  }

export function checkCartasNoche(FechaInicio,HoraActual)
{
    
    const HorarioInicio = FechaInicio.split("T")[1];
    const HorarioFin = "06:00";


    const horaInicioEnMinutos = convertirHoraAMinutos(HorarioInicio);
    const horaActualEnMinutos = convertirHoraAMinutos(HoraActual);
    const horaMaximaEnMinutos = convertirHoraAMinutos("06:00");
    


    if (horaActualEnMinutos >= horaInicioEnMinutos && horaActualEnMinutos < horaMaximaEnMinutos) {
        return true;
    }
    
      // De lo contrario, desactivar modo noche.
    return false;
}